import { logEvent } from 'firebase/analytics';
import { getFirebaseAnalytics } from '../firebase';

export async function trackPageView(path: string) {
  const analytics = await getFirebaseAnalytics();
  if (!analytics || typeof window === 'undefined') return;

  logEvent(analytics, 'page_view', {
    page_location: window.location.href,
    page_path: path,
    page_title: document.title || path
  });
}

export async function trackEvent(name: string, params?: Record<string, string | number | boolean | null | undefined>) {
  const analytics = await getFirebaseAnalytics();
  if (!analytics) return;
  logEvent(analytics, name, params);
}
